import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { SubscriptionService } from 'src/app/modules/subscription/services/subscription.service';

@Component({
  selector: 'app-purchase-modal',
  templateUrl: './purchase-modal.component.html',
  styleUrls: ['./purchase-modal.component.css'],
})
export class PurchaseModalComponent implements OnInit {
  nerPurcaseModal: any
  constructor(private dialog: MatDialog,private subscriptionService: SubscriptionService,  private mapService: MapServiceService) {
    //modal when user purchase map for first time
  }

  ngOnInit(): void {
      this.nerPurcaseModal = this.subscriptionService.getAllModals.new_purchase

  }

  closeDialog(): void {
    this.dialog.closeAll();
  }
}
